import React from 'react'

/** V3-local close (extracted from V1 DesignSystem/Icons/Close). Fill-based 24×24 mark for search-clear and icon buttons. */
const Close = ({ width = 16, height = 16, fill = 'currentColor' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={fill}
      d="M12.88 12L17.82 7.06C18.06 6.82 18.06 6.42 17.82 6.18C17.58 5.94 17.18 5.94 16.94 6.18L12 11.12L7.06 6.18C6.82 5.94 6.42 5.94 6.18 6.18C5.94 6.42 5.94 6.82 6.18 7.06L11.12 12L6.18 16.94C5.94 17.18 5.94 17.58 6.18 17.82C6.3 17.94 6.46 18 6.62 18C6.78 18 6.94 17.94 7.06 17.82L12 12.88L16.94 17.82C17.06 17.94 17.22 18 17.38 18C17.54 18 17.7 17.94 17.82 17.82C18.06 17.58 18.06 17.18 17.82 16.94L12.88 12Z"
    />
  </svg>
)

export default Close
